import React from "react";
import MortgageDetail from "./MortgageDetail";
import styled from "styled-components";
import BaseModal, {MODALSIZES} from "../../../Modals/BaseModal";

export default styled((props) => {
    return (
        <BaseModal backdropClassName={"modal-backdrop-glass"} modalId={props.modalId} onClose={props.onCloseModal} modalSize={MODALSIZES.FULL}>
            <MortgageDetail {...props} />
        </BaseModal>
    )
})`
padding-top: ${props => (props.headerHeight || 0) + 38}px;

.modal-dialog{
    width: 100%;
    max-width: 100%;
}

.close-container {
    left: 0;
    top: ${props => (props.headerHeight || 0) + 3}px;
    z-index: 2000;
}

.close-icon {
    width: 14px;
}
`;